import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { Text } from '../../atoms';

const CardWrapper = styled.div`
  width: 100%;
  padding: ${theme.spacing.xl} ${theme.spacing.l};
  border-radius: ${theme.surface.borderRadius};
  box-shadow: 0px 5px 15px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  position: relative;
`;

const QuestionCard = ({ children, date, ...props }) => {
  return (
    <CardWrapper style={{ ...props.style }}>
      <Text
        block
        strong
        color={theme.colors.fontBase}
        style={{ textAlign: 'center' }}
      >
        {children}
      </Text>
      <Text
        size="xs"
        color={theme.colors.placeholder}
        style={{
          position: 'absolute',
          right: theme.spacing.m,
          bottom: theme.spacing.s,
        }}
      >
        {date}
      </Text>
    </CardWrapper>
  );
};

QuestionCard.propTypes = {
  children: PropTypes.node.isRequired,
  date: PropTypes.string,
  style: PropTypes.object,
};

QuestionCard.defaultProps = {
  date: '',
  style: {},
};

export default QuestionCard;
